'use strict';

const React = require('react');
const Picture = require('../elements/Picture');
const NewsTeaser = ({model}) => {
	if (!model) { return (<noscript/>); }

	/* For screen readers, we only show the most relevant information in teaser */
	const ariaText = model.section + ", " + model.title;

	return (
		<a className="svtse_news-teaser" href={model.targetUrl} aria-label={ariaText}>
			<article className="svt_mediablock">
				<Picture model={model.cover} type="square" className="svt_mediablock__fig svtse_news-teaser__fig-width" imageClass="svtse_mediablock__img" />
				<div className="svt_mediablock__text">
					<div className="svtse_news-teaser__align">
						<span className="svtse_news-teaser__destination">{model.section}</span>
						<h2 className="svtse_news-teaser__header">
							{model.title}
						</h2>
					</div>
				</div>
			</article>
		</a>
	);
};

module.exports = NewsTeaser;



/** WEBPACK FOOTER **
 ** ./app/components/news/NewsTeaser.js
 **/